export default {
  root: {
    background: 'var(--box-bg-color)',
    borderRadius: '0.5rem',
    color: 'var(--text-color)',
    shadow: 'none',
  },
  body: {
    padding: '1rem',
    gap: '0.5rem',
  },
  caption: {
    gap: '0.5rem',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: '500',
  },
  subtitle: {
    color: '{text.muted.color}',
  },
};
